import * as tslib_1 from "tslib";
import RuleRow from 'owa-rules-option-common/lib/components/RuleRow';
import editInboxRule from '../actions/editInboxRule';
import enableDisableInboxRule from '../actions/enableDisableInboxRule';
import removeInboxRule from '../actions/removeInboxRule';
import store from '../store/store';
import { observer } from 'mobx-react';
import DragAndDroppable from 'owa-dnd/lib/components/DragAndDroppable';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { lazyMoveInboxRule } from 'owa-inbox-rules-option';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import canRunRule from '../utils/canRunRule';
import runRuleNow from '../actions/actionCreators/runRuleNow';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { isBulkActionRunning, isBulkActionUninitialized } from 'owa-bulk-action-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import isRuleRunning from '../selectors/isRuleRunning';
var styles = require('./InboxRuleRow.scss');
var classNames = require('classnames/bind').bind(styles);
var InboxRuleRow = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRuleRow, _super);
    function InboxRuleRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Helper method that handles user click on toggle
         * @param shouldBeEnabled whether rule should be enabled
         */
        _this.onEnableDisableInboxRule = function (shouldBeEnabled) {
            enableDisableInboxRule(_this.props.inboxRuleId, shouldBeEnabled);
        };
        /**
         * Helper method that handles user click on delete
         */
        _this.onRemoveInboxRule = function () {
            var inboxRuleRow = store.inboxRulesListState.inboxRules.get(_this.props.inboxRuleId);
            removeInboxRule(inboxRuleRow);
        };
        /**
         * Helper method that handles user click on edit
         * @param shouldMoveUp whether rule should be moved up
         */
        _this.onMoveRule = function (shouldMoveUp) {
            var inboxRuleIds = store.inboxRulesListState.inboxRuleIds;
            var ruleToMoveIndex = inboxRuleIds.indexOf(_this.props.inboxRuleId);
            var destinationRuleId = shouldMoveUp
                ? inboxRuleIds[ruleToMoveIndex - 1]
                : inboxRuleIds[ruleToMoveIndex + 1];
            // Moves rule to new position
            lazyMoveInboxRule.importAndExecute(_this.props.inboxRuleId /* idToUpdate */, destinationRuleId /* destinationRuleId */, false /* isDragAndDrop */);
        };
        /**
         * Helper method that handles user click on edit
         */
        _this.onEditInboxRule = function () {
            editInboxRule(_this.props.inboxRuleId);
        };
        _this.getDragData = function () {
            var inboxRuleId = _this.props.inboxRuleId;
            var ruleRowDragData = {
                itemType: DraggableItemTypes.InboxRule,
                ruleId: inboxRuleId,
                ruleName: store.inboxRulesListState.inboxRules.get(inboxRuleId).Name,
            };
            return ruleRowDragData;
        };
        _this.getDragPreview = function (ruleDragData) {
            var elem = document.createElement('div');
            elem.className = styles.dragHelperStyle;
            elem.innerText = ruleDragData.ruleName;
            return elem;
        };
        _this.canDrop = function (dragData) {
            return dragData.itemType === DraggableItemTypes.InboxRule;
        };
        _this.onDrop = function (dragData) {
            var draggedRule = dragData;
            var draggedRuleId = draggedRule.ruleId;
            var dragTargetRuleId = _this.props.inboxRuleId;
            // Moves rule to new position
            lazyMoveInboxRule.importAndExecute(draggedRuleId /* idToUpdate */, dragTargetRuleId /* destinationRuleId */, true /* isDragAndDrop */);
        };
        _this.runRuleNow = function () {
            var inboxRuleRow = store.inboxRulesListState.inboxRules.get(_this.props.inboxRuleId);
            runRuleNow(inboxRuleRow);
        };
        return _this;
    }
    InboxRuleRow.prototype.shouldEnableEdit = function (inboxRuleRow) {
        // Do not enable editing if the rule is not supported by OWA OR
        // rule has a clause type we don't support just yet
        // VSTS: 23316 and 23317 Add remaining conditions, actions, and exceptions
        // Check that the rule user wants to edit does not have any clauses that have
        // not been implemented yet.
        return (inboxRuleRow.SupportedByTask &&
            (!inboxRuleRow.ApplyCategory || isControlFeatureEnabled('tri-categories-parity')) &&
            !inboxRuleRow.ApplySystemCategory &&
            !inboxRuleRow.HasClassification &&
            !inboxRuleRow.ExceptIfHasClassification &&
            !inboxRuleRow.FromSubscription &&
            !inboxRuleRow.ExceptIfFromSubscription &&
            !inboxRuleRow.SendTextMessageNotificationTo);
    };
    InboxRuleRow.prototype.render = function () {
        var ruleId = this.props.inboxRuleId;
        var ruleRowIds = store.inboxRulesListState.inboxRuleIds;
        var inboxRuleRow = store.inboxRulesListState.inboxRules.get(ruleId);
        var descriptionText = this.getDescriptionText(inboxRuleRow.Description);
        var isRuleSupported = inboxRuleRow.SupportedByTask;
        var warningMessages = inboxRuleRow.WarningMessages;
        var isToggleDisabled = !!warningMessages;
        var isToggleChecked = !isToggleDisabled && inboxRuleRow.Enabled;
        var alertString = this.getAlertString(isRuleSupported, warningMessages);
        var inboxRuleRowClassName = classNames(inboxRuleRow.drop.isDragOver && styles.showBorderOnDroppedOver);
        var ruleIndex = ruleRowIds.indexOf(ruleId);
        var canRunRuleNow = canRunRule(inboxRuleRow) &&
            inboxRuleRow.SupportedByTask &&
            isMailFeatureEnabled('tri-bulkActionNotification') &&
            isMailFeatureEnabled('tri-runRulesNow');
        var shouldDisableRunRuleNow = isBulkActionRunning(folderNameToId('inbox')) ||
            isBulkActionUninitialized(folderNameToId('inbox'));
        return (React.createElement(DragAndDroppable, { getDragData: this.getDragData, getDragPreview: this.getDragPreview, dropViewState: inboxRuleRow.drop, onDrop: this.onDrop, canDrop: this.canDrop },
            React.createElement(RuleRow, { key: ruleId, ruleName: inboxRuleRow.Name, ruleDescription: isRuleSupported ? descriptionText : null, isChecked: isToggleChecked, isDisabled: isToggleDisabled, enableDisableRule: this.onEnableDisableInboxRule, removeRule: this.onRemoveInboxRule, editRule: this.shouldEnableEdit(inboxRuleRow) ? this.onEditInboxRule : null, moveRule: this.onMoveRule, disableDownArrow: ruleIndex == ruleRowIds.length - 1, disableUpArrow: ruleIndex == 0, alertString: alertString, customClassNames: inboxRuleRowClassName, runRuleNow: canRunRuleNow ? this.runRuleNow : null, disableRunRuleNow: shouldDisableRunRuleNow, isRuleRunning: isRuleRunning(ruleId, folderNameToId('inbox')), onDoubleClick: this.shouldEnableEdit(inboxRuleRow) ? this.onEditInboxRule : null })));
    };
    /**
     * Gets the description text for the given inbox rule
     * @param inboxRuleDescriptions the inbox rule clause descriptions
     * @return inbox rule description
     */
    InboxRuleRow.prototype.getDescriptionText = function (inboxRuleDescriptions) {
        var andDelimeter = ' ' + strings.options_inboxRules_and + ' ';
        var orDelimeter = ' ' + strings.options_inboxRules_or + ' ';
        var commaDelimeter = ', ';
        var period = '.';
        // Create the description string from all the clauses
        // For example: If <conditional clause 1>, <conditional clause 2> and <conditional clause 3>,
        // <action clause 1>, <action clause 2> and <action clause 3>,
        // except when <exception clause 1>, <exception clause 2> or <exception clause 3>
        var descriptionText = strings.options_inboxRules_if + ' ';
        // If there are no conditions, that means it is the 'any' clause so append the 'any' clause description
        if (inboxRuleDescriptions.ConditionDescriptions.length === 0) {
            descriptionText += strings.options_inboxRules_anyClauseDescription;
        }
        else {
            descriptionText += this.getDescriptionTextHelper(inboxRuleDescriptions.ConditionDescriptions, commaDelimeter, andDelimeter);
        }
        descriptionText += commaDelimeter;
        descriptionText += this.getDescriptionTextHelper(inboxRuleDescriptions.ActionDescriptions, commaDelimeter, andDelimeter);
        var exceptionDescriptions = inboxRuleDescriptions.ExceptionDescriptions;
        if (exceptionDescriptions.length > 0) {
            descriptionText += commaDelimeter + strings.options_inboxRules_exceptWhen + ' ';
            descriptionText += this.getDescriptionTextHelper(inboxRuleDescriptions.ExceptionDescriptions, commaDelimeter, orDelimeter);
        }
        descriptionText += period;
        return descriptionText;
    };
    /**
     * Gets the description text for a clause for the given inbox rule (conditional, action, exception)
     * @param descriptions the descriptions for an inbox rule's clause
     * @param midDelimeter the delimeter for between clauses except between the second to last and last clauses
     * @param lastDelimeter the delimeter for between the second to last and last clauses
     * @return the concatenated, user-ready description for an inbox rule's clause
     */
    InboxRuleRow.prototype.getDescriptionTextHelper = function (descriptions, midDelimeter, lastDelimeter) {
        var descriptionText = '';
        for (var i = 0; i < descriptions.length; i++) {
            descriptionText += descriptions[i];
            // Clauses should be separated by ',' except for between the second to last and last clauses,
            // which should be separated by 'and'
            if (i < descriptions.length - 2) {
                descriptionText += midDelimeter;
            }
            else if (i === descriptions.length - 2) {
                descriptionText += lastDelimeter;
            }
        }
        return descriptionText;
    };
    /**
     * Helper method that gets alert strings for rules
     * @param isRuleSupported whether rule is supported in OWA
     * @param warningMessages warning messages if the rule is broken
     * @return Alert string
     */
    InboxRuleRow.prototype.getAlertString = function (isRuleSupported, warningMessages) {
        var alertString = '';
        var spaceDelimeter = ' ';
        if (!isRuleSupported) {
            alertString += strings.options_inboxRules_differentOutlookError + spaceDelimeter;
        }
        if (warningMessages) {
            for (var _i = 0, warningMessages_1 = warningMessages; _i < warningMessages_1.length; _i++) {
                var warningMessage = warningMessages_1[_i];
                alertString += warningMessage + spaceDelimeter;
            }
        }
        return alertString;
    };
    InboxRuleRow = tslib_1.__decorate([
        observer
    ], InboxRuleRow);
    return InboxRuleRow;
}(React.Component));
export default InboxRuleRow;
//# sourceMappingURL=InboxRuleRow.js.map